import { FinalReport } from "src/entities/finalReport";

export const FinalReportPage = () => {
  return <FinalReport />;
};
